import * as types from './actionsTypes.codeMetaData';
import {
    put,
    takeEvery,
    call
} from 'redux-saga/effects';
import projectHelper from '../../services/ProjectHelper';
import { ICheckErrorsParam, IParseAllScriptsParam, IParseCodeParam } from './actions.codeMetaData';
import { IBaseAction } from '../base';
import store from '../../store';

//@ts-ignore
const parser = new Worker(new URL('../../workers/flow-parser', import.meta.url));
//@ts-ignore
const errorParser = new Worker(new URL('../../workers/error-checker', import.meta.url));

export function* parseCode({ codeString, fileName }) {
    const event = new Promise((resolve) => {
        parser.onmessage = resolve;
    });

    yield put({
        type: types.CODE_PARSING_REQ,
    });

    yield parser.postMessage({ code: codeString, fileName });

    const parserData = (yield event).data;

    yield put({
        type: types.CODE_META_DATA_CHANGE,
        ...parserData
    });
}

export function* parseAllScripts({ project }: IParseAllScriptsParam) {
    const scripts = project.scripts;
    const onlyScripts = scripts.filter(s => s.type !== 'transform');
    const scriptsCount = onlyScripts?.length;

    yield put({ type: types.SCRIPR_PARSED_OK, parsedScriptsInfo: { scriptsCount, parsedScriptsCount: 0 } });


    const event = new Promise((resolve) => {
        let countResponses = 0;
        parser.onmessage = (data) => {
            countResponses = countResponses + 1;
            store.dispatch(
                { type: types.SCRIPR_PARSED_OK, parsedScriptsInfo: { scriptsCount, parsedScriptsCount: countResponses } }
            );

            if (scriptsCount === countResponses) {
                resolve(data);
            }
        };
    });

    for (let i = 0; i < onlyScripts.length; i++) {
        const script = onlyScripts[i];
        yield parser.postMessage({ code: script.text, fileName: script.name, keepData: true });

    }



    const parserData = (yield event).data;

    yield put({
        type: types.CODE_META_DATA_CHANGE,
        ...parserData
    });
}


export function* parseErrors({ project, scripts }) {
    const event = new Promise((resolve) => {
        errorParser.onmessage = resolve;
    });

    yield errorParser.postMessage({ scripts: scripts?.filter(s => s.type !== 'transform') });

    const evt = yield event;

    const {
        syntaxErrors,
    } = evt.data;

    const hasUnsavedChanges = yield call(projectHelper.hasUnsavedChanges, project);

    yield put({
        type: types.ERRORS_CHANGE,
        syntaxErrors,
        hasUnsavedChanges
    });
}

export function* watch() {
    yield takeEvery<IParseCodeParam & IBaseAction>(types.CODE_CHANGE, parseCode);
    yield takeEvery<IParseAllScriptsParam & IBaseAction>(types.PARSE_ALL_SCRIPTS, parseAllScripts);
    yield takeEvery<ICheckErrorsParam & IBaseAction>(types.CHECK_ERRORS, parseErrors);
}
